<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-05-15 09:04:23
 * @LastEditTime : 2023-06-06 10:45:47
 * @LastEditors  : Luzx
 * @Description  : 内部单位合同
 * @FilePath     : \icps_fb\src\views\platform\ICPS\GHnumber\components\internalunit.vue
-->
<template>
    <div class="table outsourcing">
        <div class="card">
            <div class="card_nav">
                <div>
                    <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small"
                        class="bottom_all" style="margin-left: 0" @click="addFromDate('添加'), reset()">
                        <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                        添加
                    </el-button>
                    <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'RIYONG') !== -1" size="small"
                        class="bottom_three" @click="UpdateOrDeleteHandle(1)">
                        <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px"></i>
                        启用
                    </el-button>
                    <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'JINYONG') !== -1" size="small"
                        class="bottom_four" @click="UpdateOrDeleteHandle(0)">
                        <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px"></i>
                        禁用
                    </el-button>
                    <el-button v-if="ButtonList.some(res => res.buttonValue == 'TIAOJIA')" size="small" class="botton_five"
                        :disabled="yiFenPeiRadio == ''" @click="riseInPriceQueryOneByidFun(yiFenPeiRadio)">调价</el-button>
                    <el-button v-if="ButtonList.some(res => res.buttonValue == 'KAIHUXINXI')" size="small"
                        class="botton_five" :disabled="yiFenPeiRadio == ''"
                        @click="queryListsByPidFun(yiFenPeiRadio)">开户信息</el-button>
                    <el-button v-if="ButtonList.some(res => res.buttonValue == 'FENPEIZHANGHAO')" size="small"
                        class="botton_five" :disabled="yiFenPeiRadio == ''"
                        @click="open(yiFenPeiRadio, 'dialog1')">分配账号</el-button>
                </div>
                <div>
                    <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                        <el-link :underline="false">
                            <span class="el-icon--left">
                                <i class="iconfont iconicon_button_filtrate"></i>
                            </span>
                            筛选
                        </el-link>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item, index) in table" :key="index">
                                <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'DAOCHU') !== -1" :underline="false"
                        @click="load()">
                        <span class="el-icon--left">
                            <i class="iconfont iconicon_button_export1"></i>
                        </span>
                        导出
                    </el-link>
                </div>
            </div>
            <div v-loading="tableLoading" class="card_info">
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55">
                        <template slot-scope="scope">
                            <el-radio v-model="yiFenPeiRadio" :label="scope.row">{{ "" }}</el-radio>
                        </template>
                    </el-table-column>
                    <template v-for="(item, index2) in table">
                        <el-table-column v-if="item.label == '操作'" :key="index2" fixed="right" :label="item.label"
                            align="center" :width="item.width">
                            <template slot-scope="scope">
                                <!-- <el-dropdown :hide-on-click="false" trigger="click">
                                    
                                </el-dropdown> -->
                                <el-button v-if="scope.row.enable == 1" size="mini" class="bottom_one"
                                    @click="contractQueryDetailByIdFun(scope.row.id), (addDialogTitle = '修改'), (modifyType = false)">修改</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column v-else-if="item.status" :key="index2" :label="item.label" align="center"
                            :width="item.width">
                            <template slot-scope="scope">
                                <div v-if="item.label == '状态'">
                                    <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
                                    <span v-else-if="scope.row.enable == 1" style="color: #00a754">启用</span>
                                </div>
                                <div v-else-if="item.label == '合同类型'">
                                    <span v-if="scope.row.contractTypeId == 1">购销</span>
                                    <span v-else-if="scope.row.contractTypeId == 2">代加工</span>
                                </div>
                                <div v-else-if="item.label == '合同有效期'">
                                    {{ scope.row.startTime }} - {{ scope.row.endTime }}
                                </div>
                                <span v-else>{{ scope.row[item.prop] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange"
                        @current-change="gettableData(), (yiFenPeiRadio = '')"></el-pagination>
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
        </div>
        <!-- 添加·合同 -->
        <el-dialog v-dialogDrag :visible.sync="addDialog" width="1015px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
            <div class="dialoginfo FZYform scroll" style="height: calc(85vh - 230px); padding-right: 5px; overflow: auto">
                <el-form ref="reffromDate" :rules="rules" :inline="true" :model="formDate" label-width="110px">
                    <div class="form-title">基本信息</div>
                    <el-form-item prop="contractTypeId">
                        <span slot="label">合同类型</span>
                        <el-select v-model="formDate.contractTypeId" placeholder="请选择" :disabled="modifyType">
                            <el-option label="购销" :value="1"></el-option>
                            <el-option label="代加工" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="firstPartyId">
                        <span slot="label">甲方单位</span>
                        <el-select ref="selection1" v-model="formDate.firstPartyId" placeholder="请选择" :disabled="modifyType"
                            @change="
                                changemainCompanyId(formDate.firstPartyId),
                                $nextTick(() => {
                                    formDate.firstParty = $refs.selection1.selectedLabel;
                                })
                                ">
                            <el-option v-for="(item, index) in companylist" :key="index" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="secondPartyId">
                        <span slot="label">乙方单位</span>
                        <el-select ref="selection2" v-model="formDate.secondPartyId" placeholder="请选择"
                            :disabled="modifyType" @change="
                                changesecondCompanyId(formDate.secondPartyId),
                                // companylistSecondChangeFun(true, formDate.secondPartyId),
                                $nextTick(() => {
                                    formDate.secondParty = $refs.selection2.selectedLabel;
                                })
                                ">
                            <el-option v-for="(item, index) in companylist" :key="index" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="contractTypeId">
                        <span slot="label">合同编号</span>
                        <el-input v-model="formDate.contractNumber" type="text" placeholder="请输入" clearable ></el-input>
                    </el-form-item>
                    <el-form-item prop="startDayendDay">
                        <span slot="label">合同有效期</span>
                        <el-date-picker v-model="formDate.startDayendDay" unlink-panels style="width: 340px"
                            type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期"
                            end-placeholder="结束日期" :disabled="modifyType"></el-date-picker>
                    </el-form-item>
                    <div class="form-title">费用信息</div>
                    <el-row v-if="formDate.contractTypeId == 1">
                        <el-col :span="24">
                            <el-form-item prop="productPrice" label-width="110px">
                                <span slot="label" style="position: relative; top: 6px">产品费用</span>
                                <span style="margin-right:10px">在甲方合同基础上，增加</span>
                                <el-input v-model="formDate.productPrice" type="Number" placeholder="请输入" clearable
                                    :disabled="modifyType" style="width: 140px"></el-input>
                                <span style="margin-left: 10px">
                                    元/m
                                    <sup>3</sup>
                                </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="formDate.contractTypeId == 2">
                        <el-col :span="24">
                            <el-form-item prop="processPrice" label-width="140px">
                                <span slot="label" style="position: relative; top: 6px">加工费（含税）</span>
                                <el-input v-model="formDate.processPrice" type="Number" placeholder="请输入" clearable
                                    :disabled="modifyType" style="width: 140px"></el-input>
                                <span style="margin-left: 10px">
                                    元/m
                                    <sup>3</sup>
                                </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item>
                        <span slot="label">合同条款</span>
                        <el-input v-model="formDate.contractClause" style="width: 800px" type="textarea"
                            placeholder="请输入合同条款内容" clearable :rows="2" resize="none" :disabled="modifyType" maxlength="200"
                            show-word-limit></el-input>
                    </el-form-item>
                    <div class="form-title">附件</div>
                    <FileComponent fileCode="intervalunitFile" :disabled="modifyType" :files="files"
                        @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="addDialog = false">关 闭</el-button>
                <el-button v-show="!modifyType" class="bottom_all" style="margin-left: 24px" :disabled="modifyType"
                    @click="pagessubmitFromDate()">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 业务管控点 -->
        <el-dialog v-dialogDrag :visible.sync="controlPoint_Dialog" width="800px">
            <span slot="title" class="dialog-title">管控业务点设置</span>
            <div class="dialoginfo">
                <div class="FZYguanKongYeWuDian">
                    <table>
                        管控业务点：
                    </table>
                    <div class="FZYcheckbox">
                        <div v-if="formDate.processModel == 1">
                            <el-checkbox v-for="(v, k) in businessCheckbox" :key="k" :label="v.id" :disabled="true"
                                checked>{{ v.itemName }}</el-checkbox>
                        </div>
                        <el-checkbox-group v-else v-model="formDate.business">
                            <el-checkbox v-for="item in businessCheckbox" :key="item.id" :label="item.id"
                                :disabled="modifyType">{{ item.itemName }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all" style="margin-left: 24px" @click="controlPoint_Dialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 站点运输价及到岸价查看 -->
        <el-dialog v-dialogDrag :visible.sync="thePrice_Dialog" width="550px">
            <span slot="title" class="dialog-title">站点运输价及到岸价</span>
            <div class="dialoginfo"></div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="thePrice_Dialog = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 协作单位 -->
        <el-dialog v-dialogDrag :visible.sync="cooperativeUnit_Dialog" width="550px">
            <span slot="title" class="dialog-title">协作单位</span>
            <div class="dialoginfo">
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="cooperativeUnitArr" tooltip-effect="dark">
                    <el-table-column label="协作单位" align="center" prop="name"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="cooperativeUnit_Dialog = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 合同产品列表 -->
        <el-dialog v-dialogDrag :visible.sync="riseInPriceQueryOneByidType" width="800px">
            <span slot="title" class="dialog-title">合同产品列表</span>
            <div class="dialoginfo">
                <div class="form-title">运距价格设置</div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="[{ id: 1, name: '运距调价' }]" tooltip-effect="dark" class="FZYselectList">
                    <el-table-column label="运距调价" align="center" width="250" prop="name"></el-table-column>
                    <el-table-column label="单价" align="center">
                        <template slot-scope="scope">
                            <el-link class="table_link" :underline="false"
                                @click="QueryOneByidFun(scope.row, true)">价格设置</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="form-title">泵送价格设置</div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="pumpPriceArr" tooltip-effect="dark" class="FZYselectList">
                    <el-table-column label="泵车类型" align="center" width="250">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.costId" size="mini" placeholder="选择" disabled
                                style="width: 100% !important">
                                <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName"
                                    :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="单价" align="center">
                        <template slot-scope="scope">
                            <el-link class="table_link" :underline="false"
                                @click="QueryOneByidFun(scope.row, true)">价格设置</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="form-title">产品价格设置</div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="goodPriceArr" tooltip-effect="dark" class="FZYselectList">
                    <el-table-column label="强度等级" align="center" width="250">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.costId" size="mini" placeholder="选择" disabled
                                style="width: 100% !important">
                                <el-option v-for="item in goodPriceList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="单价" align="center">
                        <template slot-scope="scope">
                            <el-link class="table_link" :underline="false"
                                @click="QueryOneByidFun(scope.row, false)">价格设置</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="form-title">附加收费项价格</div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="fuPriceArr" tooltip-effect="dark" class="FZYselectList">
                    <el-table-column label="附加收费项" align="center" width="250">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.costId" size="mini" placeholder="选择" disabled
                                style="width: 100% !important">
                                <el-option v-for="item in fuPriceList" :key="item.ID" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="附加收费" align="center">
                        <template slot-scope="scope">
                            <el-link class="table_link" :underline="false"
                                @click="QueryOneByidFun(scope.row, false)">价格设置</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="riseInPriceQueryOneByidType = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 价格区间弹窗 -->
        <el-dialog v-dialogDrag :visible.sync="basePriceListType" width="800px">
            <span slot="title" class="dialog-title">设置泵送高度</span>
            <div class="dialoginfo FZY1-3">
                <div v-for="(v3, k3) in carTwosArr" :key="k3">
                    <div v-if="k3 == 0" class="liBox1">
                        <div>
                            <span>小于等于</span>
                            <el-input-number v-model="v3.distance" size="mini" :controls="false" :precision="2"
                                :disabled="modifyType"
                                @blur="inpuSizeCheck2(v3.distance, k3, carTwosArr)"></el-input-number>
                        </div>
                        <div>
                            <span>米</span>
                            <b>：</b>
                            <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                                :disabled="modifyType"></el-input-number>
                            <span>元/方</span>
                        </div>
                    </div>
                    <div v-if="k3 > 0 && k3 != carTwosArr.length - 1" class="liBox3">
                        <div>
                            <div>
                                <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false"
                                    :precision="2" disabled></el-input-number>
                                <span>至</span>
                                <el-input-number v-model="v3.distance" size="mini" :controls="false" :precision="2"
                                    :disabled="modifyType"
                                    @blur="inpuSizeCheck2(v3.distance, k3, carTwosArr)"></el-input-number>
                            </div>
                            <div>
                                <span>米</span>
                                <b>：</b>
                                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                                    :disabled="modifyType"></el-input-number>
                                <span>元/方</span>
                            </div>
                        </div>
                        <div>
                            <el-button v-if="carTwosArr.length - 2 == k3" class="bottom_text" :disabled="modifyType"
                                @click="addJson2()">添加区间</el-button>
                            <el-button v-else class="bottom_text" :disabled="modifyType"
                                @click="delJson2(k3)">删除区间</el-button>
                        </div>
                    </div>
                    <div v-if="k3 == carTwosArr.length - 1" class="liBox2" style="width: 100%">
                        <div>
                            <span>大于</span>
                            <el-input-number v-model="carTwosArr[k3 - 1].distance" size="mini" :controls="false"
                                :precision="2" disabled></el-input-number>
                        </div>
                        <div>
                            <span>米</span>
                            <b>：</b>
                            <span>每增加</span>
                            <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0"
                                style="width: 80px" :disabled="modifyType"></el-input-number>
                            <span>米，增加</span>
                            <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px"
                                :disabled="modifyType"></el-input-number>
                            <span>元/方</span>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="basePriceListType = false">取 消</el-button>
                <el-button class="bottom_all" style="margin-left: 24px" @click="basePriceListUpFun()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 价格设置-调价详情 -->
        <el-dialog v-dialogDrag :visible.sync="QueryOneByidType" width="800px">
            <span slot="title" class="dialog-title">价格设置</span>
            <div class="dialoginfo">
                <div v-show="$options.filters.moneyFun(moneyType)" class="FZY1-3"
                    style="border-bottom: 0px; margin-bottom: 10px">
                    <div v-for="(v3, k3) in carTwosArr" :key="k3">
                        <div v-if="k3 == 0" class="liBox1">
                            <div>
                                <span>小于</span>
                                <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                                    disabled></el-input-number>
                            </div>
                            <div>
                                <span>千米</span>
                                <b>：</b>
                                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                                    :disabled="modifyType"></el-input-number>
                                <span>元/方</span>
                            </div>
                        </div>
                        <div v-if="k3 > 0 && k3 != carTwosArr.length - 1" class="liBox3">
                            <div>
                                <div>
                                    <el-input-number v-model="v3.minDistance" size="mini" :controls="false" :precision="2"
                                        :disabled="modifyType" @change="carTwosArr[k3 - 1].maxDistance = v3.minDistance"
                                        @blur="inpuSizeCheck3(v3.minDistance, k3, carTwosArr)"></el-input-number>
                                    <span>至</span>
                                    <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                                        disabled></el-input-number>
                                </div>
                                <div>
                                    <span>千米</span>
                                    <b>：</b>
                                    <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                                        :disabled="modifyType"></el-input-number>
                                    <span>元/方</span>
                                </div>
                            </div>
                            <div>
                                <el-button v-if="carTwosArr.length - 2 == k3" class="bottom_text" :disabled="modifyType"
                                    @click="addJson2()">添加区间</el-button>
                                <el-button v-else class="bottom_text" :disabled="modifyType"
                                    @click="delJson2(k3)">删除区间</el-button>
                            </div>
                        </div>
                        <div v-if="k3 == carTwosArr.length - 1" class="liBox2" style="width: 100%">
                            <div>
                                <span>大于</span>
                                <el-input-number v-model="v3.minDistance" size="mini" :controls="false" :precision="2"
                                    :disabled="modifyType" @change="carTwosArr[k3 - 1].maxDistance = v3.minDistance"
                                    @blur="inpuSizeCheck3(v3.minDistance, k3, carTwosArr)"></el-input-number>
                            </div>
                            <div>
                                <span>千米</span>
                                <b>：</b>
                                <span>每增加</span>
                                <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0"
                                    style="width: 80px" :disabled="modifyType"></el-input-number>
                                <span>千米，增加</span>
                                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                                    style="width: 80px" :disabled="modifyType"></el-input-number>
                                <span>元/方</span>
                            </div>
                        </div>
                    </div>
                </div>
                <el-form ref="contractRawMoneySaveForm" label-width="80px" :model="contractRawMoneySaveForm"
                    :rules="contractRawMoneySaveFormRules" class="FZYform2">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item v-if="!$options.filters.moneyFun(moneyType)" label="价格" prop="money">
                                <el-input v-model="contractRawMoneySaveForm.money" type="Number" placeholder>
                                    <template slot="append">元/吨</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="生效日期" prop="startTime">
                                <el-date-picker v-model="contractRawMoneySaveForm.startTime" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div style="margin-left: 24px">
                                <FileComponent2 fileCode="contractFile" :files="files2" @deleteFile="deleteFile2"
                                    @uplodeSuccess="uplodeSuccess2" />
                            </div>
                        </el-col>
                        <el-col :span="2" style="margin-bottom: 20px">
                            <el-button class="bottom_all" @click="contractRawMoneySaveFun()">添加</el-button>
                        </el-col>
                    </el-row>
                </el-form>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="QueryOneByidArr" tooltip-effect="dark">
                    <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                    <el-table-column label="价格" prop="money" align="center">
                        <template slot-scope="scope">
                            <el-link v-if="$options.filters.moneyFun(moneyType)" class="table_link" :underline="false"
                                @click="basePriceListFun2(scope.row)">查看</el-link>
                            <span v-else>{{ scope.row.money }} 元/吨</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="生效日期" prop="startTime" align="center"></el-table-column>
                    <el-table-column label="附件" align="center" width="120">
                        <template slot-scope="scope">
                            <el-button size="mini" class="bottom_all_two" @click="lookFile(scope)">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <el-link class="table_link" :underline="false"
                                @click="contractRawMoneyDeletesFun(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="$options.filters.moneyFun(moneyType)" class="card_bottom">
                    <div class="card_bottom_left">
                        <div class="top_page_totle">总共{{ QueryOneByidObject.total }}条</div>
                        <el-pagination :current-page.sync="QueryOneByidObject.page" :page-size="QueryOneByidObject.pageSize"
                            layout="prev, pager, next, jumper" :total="QueryOneByidObject.total"
                            @current-change="QueryOneByidFun()"></el-pagination>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="QueryOneByidType = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 价格区间弹窗 -->
        <el-dialog v-dialogDrag :visible.sync="basePriceListType2" width="800px">
            <span slot="title" class="dialog-title">泵送高度及价格</span>
            <div class="dialoginfo FZY1-3">
                <div v-for="(v3, k3) in carTwosArr2" :key="k3">
                    <div v-if="k3 == 0" class="liBox1">
                        <div>
                            <span>小于</span>
                            <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                                disabled></el-input-number>
                        </div>
                        <div>
                            <span>千米</span>
                            <b>：</b>
                            <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                                disabled></el-input-number>
                            <span>元/方</span>
                        </div>
                    </div>
                    <div v-if="k3 > 0 && k3 != carTwosArr2.length - 1" class="liBox3">
                        <div>
                            <div>
                                <el-input-number v-model="v3.minDistance" size="mini" :controls="false" :precision="2"
                                    disabled></el-input-number>
                                <span>至</span>
                                <el-input-number v-model="v3.maxDistance" size="mini" :controls="false" :precision="2"
                                    disabled></el-input-number>
                            </div>
                            <div>
                                <span>千米</span>
                                <b>：</b>
                                <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0"
                                    disabled></el-input-number>
                                <span>元/方</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="k3 == carTwosArr2.length - 1" class="liBox2" style="width: 100%">
                        <div>
                            <span>大于</span>
                            <el-input-number v-model="carTwosArr2[k3 - 1].maxDistance" size="mini" :controls="false"
                                :precision="2" disabled></el-input-number>
                        </div>
                        <div>
                            <span>千米</span>
                            <b>：</b>
                            <span>每增加</span>
                            <el-input-number v-model="v3.addDistance" size="mini" :controls="false" :min="0"
                                style="width: 80px" disabled></el-input-number>
                            <span>千米，增加</span>
                            <el-input-number v-model="v3.price" size="mini" :controls="false" :min="0" style="width: 80px"
                                disabled></el-input-number>
                            <span>元/方</span>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="basePriceListType2 = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 开户信息 -->
        <el-dialog v-dialogDrag :visible.sync="AllqueryListsByPid" width="550px">
            <span slot="title" class="dialog-title">开户信息维护</span>
            <div class="dialoginfo">
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                    style="width: 100%" :data="queryListsByPidArr" tooltip-effect="dark">
                    <el-table-column label="单位名称" prop="name" align="center"></el-table-column>
                    <el-table-column label="开户信息" align="center">
                        <template slot-scope="scope">
                            <el-link class="table_link" :underline="false"
                                @click="contractAccountGetDetailFun(scope.row.id, scope.$index + 1)">开户信息</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="AllqueryListsByPid = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 开户信息详情-编辑 -->
        <el-dialog v-dialogDrag :visible.sync="contractAccountGetDetailType" width="800px">
            <span slot="title" class="dialog-title">开户信息</span>
            <div class="dialoginfo">
                <el-form ref="contractAccountSaveForm" label-width="130px" :model="contractAccountSaveForm"
                    :rules="contractAccountSaveRules" class="FZYform2">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="法定代表人" prop="name"
                                :rules="[{ required: true, message: '请输入法定人', trigger: 'blur' }]">
                                <el-input v-model="contractAccountSaveForm.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="法人身份证号码" prop="identityCard">
                                <el-input v-model="contractAccountSaveForm.identityCard"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="合同条款" prop="contractPact"
                                :rules="[{ required: true, message: '请输入合同条款', trigger: 'blur' }]">
                                <el-input v-model="contractAccountSaveForm.contractPact"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode"
                                :rules="[{ required: true, message: '请输入信用代码', trigger: 'blur' }]">
                                <el-input v-model="contractAccountSaveForm.unifiedSocialCreditCode"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="收款方式">
                                <div style="width: 100px">现金</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单位开户银行">
                                <el-input v-model="contractAccountSaveForm.bankDepositA"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="单位开户账号">
                                <el-input v-model="contractAccountSaveForm.accountA"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开户银行联行号">
                                <el-input v-model="contractAccountSaveForm.bankNumberA"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="收款方式">
                                <div style="width: 100px">电子承兑</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单位开户银行">
                                <el-input v-model="contractAccountSaveForm.bankDepositB"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="单位开户账号">
                                <el-input v-model="contractAccountSaveForm.accountB"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开户银行联行号">
                                <el-input v-model="contractAccountSaveForm.bankNumberB"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="收款方式">
                                <div style="width: 100px">商票</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单位开户银行">
                                <el-input v-model="contractAccountSaveForm.bankDepositC"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="单位开户账号">
                                <el-input v-model="contractAccountSaveForm.accountC"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开户银行联行号">
                                <el-input v-model="contractAccountSaveForm.bankNumberC"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="收款方式">
                                <div style="width: 100px">其他</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单位开户银行">
                                <el-input v-model="contractAccountSaveForm.bankDepositD"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="单位开户账号">
                                <el-input v-model="contractAccountSaveForm.accountD"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开户银行联行号">
                                <el-input v-model="contractAccountSaveForm.bankNumberD"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="contractAccountGetDetailType = false">关 闭</el-button>
                <el-button class="bottom_all" style="margin-left: 24px" @click="contractAccountSaveFun()">保 存</el-button>
            </span>
        </el-dialog>
        <ModifyTheRecord ref="ModifyTheRecord"></ModifyTheRecord>
        <diaLog1 :dialog="dialog1" :low="low" :supplierId="supplierId" :tableData="roleList" @reset="reset1"
            @submit="submit"></diaLog1>
        <diaLog2 :dialog="dialog2" :low="low2" @reset="reset1"></diaLog2>
        <!-- 查看附件 -->
        <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
    </div>
</template>
  
<script>
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import LookFile from "@/components/File/LookFile";
import mixin from "@/mixins/ICPSmixin.js";
import FileComponent from "@/components/File/fileComponent";
import {
    post
} from '@/api/table.js';
import {
    queryPage,
    batchUpdateOrDelete,
    updateSortNum,
    saveOrUpdate,
    Download,
    // engineeringManagementQueryPage,
    processes_collection,
    contractQueryDetailById,
    QueryOneByid,
    contractRawMoneySave,
    contractRawMoneyDeletes,
    contractAccountGetDetail,
    contractAccountSave,
    PumpPriceLogQueryPage,
    PumpPriceLogSave,
    PumpPriceLogGetDetail,
    PumpPriceLogDeletes,
    queryContractNumber,
} from "@/api/GHnumber/unitinterval.js";
import { querysupplierPage, queryListsByPid } from "@/api/GHnumber/supplier.js";
import { queryMaterialsPage } from "@/api/basicConfig/Rmaterial.js";
import { getDicType, getDicsType, permissionsCompanyList } from "@/api/common.js";
import { getListByTypeId } from "@/api/common.js";
import { getLists } from "@/api/basicConfig/CCTrules.js";
import { getLists as getLists2 } from "@/api/smart/schedul/c.js";
import { getUserInfo } from "@/utils/auth.js";
// import { getUserAutList } from "@/api/common.js";
import ModifyTheRecord from "./modifyTheRecord";
import { getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
const diaLog1 = () => import("../dialog/contract1");
const diaLog2 = () => import("./dialog/engineeringControl1");
export default {
    components: { FileComponent, ModifyTheRecord, diaLog1, diaLog2, FileComponent2, LookFile },
    mixins: [mixin],
    watch: {
        "formDate.startDayendDay"() {
            this.formDate.startTime = this.formDate.startDayendDay[0];
            this.formDate.endTime = this.formDate.startDayendDay[1];
        },
        yiFenPeiRadio: {
            handler: function (val) {
                this.ids = [val.id];
            },
            deep: false,
        },
        "formDate.contractTypeId"() {
            console.log(this.rules.processPrice)
            console.log(this.rules.productPrice)
            if (this.formDate.contractTypeId == 1) {
                this.rules.processPrice = [{ required: false, message: "请输入加工费用", trigger: "change" }]
                this.rules.productPrice = [{ required: true, message: "请输入增加产品费用", trigger: "change" }]
            } else if (this.formDate.contractTypeId == 2) {
                this.rules.productPrice = [{ required: false, message: "请输入增加产品费用", trigger: "change" }]
                this.rules.processPrice = [{ required: true, message: "请输入加工费用", trigger: "change" }]
            }
        },
    },
    data() {
        var userCard = (rule, value, callback) => {
            //验证身份证号码
            var reg = new RegExp(/^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/);
            if (!reg.test(value)) {
                callback(new Error("请输入正确的身份证号码"));
            } else {
                callback();
            }
        };
        return {
            //分配账号角色列表
            roleList: [
                { roleName: "协外接单员", roleId: "299362323687149568", list: [], list1: [] },
                { roleName: "协外签票员", roleId: "299362535579193344", list: [], list1: [] },
                { roleName: "协外结算员", roleId: "299362611722588160", list: [], list1: [] },
                { roleName: "协外异常处理员", roleId: "299362713086332928", list: [], list1: [] },
            ],
            roadWorkList: [], // 合同签订主体数据
            lookFileVisible: false,
            lookFileConfig: {},
            low: "",
            low2: {},
            dialog1: false,
            dialog2: false,
            checked1: false,
            checked2: false,
            checked3: false,
            checked4: false,
            checked5: false,
            checked6: false,
            checked7: false,
            aaaaaaaaa: [],
            files: [],
            files2: [],
            UserInfo: "",
            /*表格增删改查及下载接口*/
            queryPage: queryPage,
            batchUpdateOrDelete: batchUpdateOrDelete, //启用禁用接口
            updateSortNum: updateSortNum,
            saveOrUpdate: saveOrUpdate,
            DownloadURL: Download,
            /*表格数据*/
            table: [
                { label: "合同类型", width: "120", prop: "contractTypeId", status: true },
                {
                    label: "甲方单位",
                    width: "auto",
                    prop: "firstParty",
                    status: true,
                },
                { label: "乙方单位", width: "auto", prop: "secondParty", status: true },
                { label: "合同编号", width: "auto", prop: "contractNumber", status: true },
                {
                    label: "合同有效期",
                    width: "auto",
                    prop: "startTime,endTime",
                    status: true,
                },
                { label: "状态", width: "120", prop: "enable", status: true },
                { label: "操作", width: "100", prop: "", status: true, fixed: "right" },
            ],
            modifyType: false, //修改是否可以状态
            text: "含水率规则：0≤x≤5%，按照5%结算；5%＜X≤8%，按照8%结算；8%<x≤13%，按照实测结算；13%<x，按照实测结算，并5元/吨处罚",
            clearingFromIdList: [
                // { id: '0', name: '双控' },
                // { id: '1', name: '图算' },
                { id: "2", name: "实结" },
            ], //结算方式
            companylist: [], //甲方公司
            sitelist: [], //站点名称
            supplierList: [], //主合同单位名称
            MaterialsList: [], //原物料
            AForContract: [], //是否甲供合同
            theUnitPriceSource: [
                {
                    id: "1",
                    itemName: "已信息价结算",
                },
            ], //单价来源
            engineeringManagement: [], //甲供工程
            thePrice_Dialog: false, //价格表弹窗
            controlPoint_Dialog: false, //业务管控点弹窗
            cooperativeUnit_Dialog: false, //协作单位弹窗
            rules: {
                contractTypeId: [{ required: true, message: "请选择合同类型", trigger: "change" }],
                firstPartyId: [{ required: true, message: "请选择甲方公司", trigger: "change" }],
                secondPartyId: [{ required: true, message: "请选择乙方公司", trigger: "change" }],
                startDayendDay: [{ required: true, message: "请选择合同有效期", trigger: "change" }],
                processPrice: [{ required: false, message: "请输入加工费用", trigger: "change" }],
                productPrice: [{ required: false, message: "请输入增加产品费用", trigger: "change" }]
            },
            formDate: {
                processPrice: '', //加工费用
                productPrice: '', //产品费用
                startDayendDay: [],
                id: "",
                contractTypeId: '',//合同类型id
                contractType: "",
                firstParty: "", //甲方
                firstPartyId: "", //甲方id
                secondParty: "", //乙方
                secondPartyId: "", //乙方ID
                contractNumber:'',
                accessory: [], //附件
            },
            businessCheckbox: [], //业务点
            businessCheckbox1: [{ itemName: "呜呜呜呜", id: 111 }],
            cooperativeUnitArr: [], //外协单位列表
            riseInPriceQueryOneByidType: false,
            riseInPriceQueryOneByidArr: [], //调价列表
            contractId: "", //原物料列表
            QueryOneByidType: false,
            QueryOneByidArr: [], //调价列表
            pumpTypeArr: [], //泵车类型
            cargoTypeIdArr: [
                {
                    id: 1,
                    name: "原物料",
                },
                {
                    id: 2,
                    name: "混凝土",
                },
                {
                    id: 3,
                    name: "其他",
                },
            ],
            QueryOneByidObject: {
                //调价分页
                page: 1,
                pageSize: 10,
                total: 0,
            },
            contractRawMoneySaveForm: { startTime: "" },
            contractRawMoneySaveFormRules: {
                money: [{ required: true, message: "请输入价格", trigger: "blur" }],
                startTime: [{ required: true, message: "请选择生效日期", trigger: "blur" }],
            },
            AllqueryListsByPid: false,
            queryListsByPidArr: [], //开户信息-协作单位合并列表
            contractAccountGetDetailType: false,
            //开户信息表单
            contractAccountSaveForm: {
                contractPactId: "", //合同条约id
                contractPact: "", //合同条约
            },
            contractAccountSaveRules: {
                identityCard: [{ required: true, validator: userCard, trigger: "change" }], //身份证
            },
            yunPriceArr: [], //价格区间
            pumpPriceArr: [], //泵送价格
            goodPriceArr: [], //强度等级价格
            fuPriceArr: [], //附加收费项价格
            goodPriceList: [], //强度list
            fuPriceList: [], //附加收费项list
            cplistArr: [], //供应产品列表显示部分
            strengthGradeList: [], //强度list
            performanceGradeList: [], //性能等级list
            meterialRequirementsList: [], //材料要求list
            specialRequirementsList: [], //特殊要求list
            otherRequirementsList: [], // 其他要求list
            admixtureRequirementsList: [], //外加剂要求list
            pumpTypeList: [], //浇筑方式泵机类型
            carTwosArr: [], //区间价格弹窗数组
            carTwosArrIndex: "", //当前打开的价格弹窗数组对应的表格里面的下标
            basePriceListType: false, //设置区间价格弹窗
            basePriceListType2: false, //区间价格仅仅查看的弹窗
            carTwosArr2: [], //区间价格弹窗数组
            pumpListArr: [], //泵管价格
            moneyType: false, //当前是否打开的是泵车价格
            appPackage: [],
            yiFenPeiRadio: "",
            supplierId: "",
            taxRateList: [],
        };
    },
    async created() {
        this.UserInfo = await getUserInfo();
        // this.companylist = await getUserAutList();
        this.companylist = await permissionsCompanyList();
        console.log(this.companylist)
        // const arr = this.companylist.map(item => item.children);
        // arr.forEach(item => {
        //     item.forEach(sItem => {
        //         this.sitelist.push(sItem);
        //     });
        // });
        getLists().then(res => {
            res.data.forEach(v => {
                if (v.typeName == "材料要求") {
                    this.fuPriceList = v.list;
                }
            });
        });
        getListByTypeId({
            typeId: 1,
        }).then(res => {
            this.goodPriceList = res.data;
        });
        let params = {
            page: 1,
            pageSize: 99999,
        };
        // engineeringManagementQueryPage({
        //     isAssess: 1,
        //     page: 1,
        //     pageSize: 99999,
        // }).then(res => {
        //     this.engineeringManagement = res.data.data;
        // });
        querysupplierPage(params).then(res => {
            this.supplierList = res.data.data;
        });
        queryMaterialsPage().then(res => {
            this.MaterialsList = res.data;
        });
        getDicType({ code: "castingType" }).then(res => {
            this.pumpTypeArr = res.data.items; //
        });
        getDicType({ code: "contractType" }).then(res => {
            this.contractTypeArry = res.data.items; //
        });
        getDicType({ code: "HuaXiYunCai_Registration" }).then(res => {
            this.HuaXiYunCai_RegistrationArry = res.data.items; //
        });
        getDicType({ code: "AForContract" }).then(res => {
            this.AForContract = res.data.items; //
        });
        getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
            if (res.code === 1001) {
                this.roadWorkList = res.data;
            }
        });
        getDicType({ code: "hetongsuilv" }).then(res => {
            this.taxRateList = res.data.items;
            this.taxRateList.forEach(item => {
                item.itemValue = Number(item.itemValue);
            });
        });
        getDicType({ code: "MATtype" }).then(res => {
            this.checkTypeIdList = res.data.items; //
        });
        /**浇筑方式泵机类型 */
        getDicType({
            code: "castingType",
        }).then(res => {
            res.data.items.map(v1 => (v1.type = 1));
            this.pumpTypeList = res.data.items;
            getDicType({
                code: "pouringMethod",
            }).then(res => {
                res.data.items.map(v2 => (v2.type = 2));
                this.pumpTypeList = [...this.pumpTypeList, ...res.data.items];
            });
        });
        /**
         * @Description: 获取5大参数
         * @Param:
         * @Author: wangwangwang
         */
        getLists2().then(res => {
            res.data.forEach(item => {
                if (!item) return;
                if (item.typeName == "强度等级") {
                    this.strengthGradeList = item.list;
                } else if (item.typeName == "规范性能等级") {
                    this.performanceGradeList = item.list;
                } else if (item.typeName == "材料要求") {
                    this.meterialRequirementsList = item.list;
                } else if (item.typeName == "特殊要求") {
                    this.specialRequirementsList = item.list;
                } else if (item.typeName == "外加剂要求") {
                    this.admixtureRequirementsList = item.list;
                } else if (item.typeName == "其他要求") {
                    this.otherRequirementsList = item.list;
                }
            });
        });
    },
    methods: {
        handleSelectionChange(e) {
            console.log(e)
        },
        UpdateOrDeleteHandle(e) {
            console.log(e)
            console.log(this.yiFenPeiRadio)
            let formDate = {
                enable: e,
                id: this.yiFenPeiRadio.id
            }
            this.$confirm('是否确定启用/禁用?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'bottom_all_two',
                confirmButtonClass: 'bottom_all',
                type: 'warning'
            }).then(() => {
                post(this.saveOrUpdate, formDate).then((res) => {
                    if (res.code == 1001) {
                        this.gettableData()
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                    }
                });
            })

        },
        //产品信息开始
        selectAll1() {
            if (this.checked1) {
                this.formDate.strengthGradeArr = this.strengthGradeList.map(item => item.id);
                this.formDate.strengthGradece = this.strengthGradeList;
            } else {
                this.formDate.strengthGradeArr = [];
                this.formDate.strengthGradece = [];
            }
        },
        selectAll2() {
            if (this.checked2) {
                this.formDate.performanceRequirementsArr = this.performanceGradeList.map(item => item.id);
            } else {
                this.formDate.performanceRequirementsArr = [];
            }
        },
        selectAll3() {
            if (this.checked3) {
                this.formDate.materialRequirementsArr = this.meterialRequirementsList.map(item => item.id);
            } else {
                this.formDate.materialRequirementsArr = [];
            }
        },
        selectAll4() {
            if (this.checked4) {
                this.formDate.specialRequirementsArr = this.specialRequirementsList.map(item => item.id);
            } else {
                this.formDate.specialRequirementsArr = [];
            }
        },
        selectAll5() {
            if (this.checked5) {
                this.formDate.otherRequirementsArr = this.otherRequirementsList.map(item => item.id);
            } else {
                this.formDate.otherRequirementsArr = [];
            }
        },
        selectAll6() {
            if (this.checked6) {
                this.formDate.additiveRequirementsArr = this.admixtureRequirementsList.map(item => item.id);
            } else {
                this.formDate.additiveRequirementsArr = [];
            }
        },
        selectAll7() {
            if (this.checked7) {
                this.formDate.pouringMethodArr = this.pumpTypeList.map(item => item.id);
            } else {
                this.formDate.pouringMethodArr = [];
            }
        },
        //产品信息结束
        lookFile({ row }) {
            this.lookFileVisible = true;
            this.lookFileConfig = row;
        },
        /**分配账号*/
        open(low, key) {
            this.supplierId = low.supplierId;
            this.low = low.id;
            this[key] = true;
        },
        reset1(key) {
            console.log(key)
            this[key] = false;
        },
        submit(key) {
            this[key] = false;
        },
        /**
         * @Description: 删除附件
         * @Param:
         * @Author: wangwangwang
         */
        deleteFile(index) {
            this.files.splice(index, 1);
        },
        deleteFile2(index) {
            this.files2.splice(index, 1);
        },
        /**
         * @Description: 上传成功
         * @Param:
         * @Author: wangwangwang
         */
        uplodeSuccess(data) {
            this.files.push(data);
        },
        uplodeSuccess2(data) {
            const params = {
                name: data.fileName,
                fileName: data.fileName,
                fileUrl: data.fileUrl,
                path: data.fileUrl,
                fileType: 1,
                type: 1,
                createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
            };
            this.files2.push(params);
        },
        //暂存价格区间设置
        basePriceListUpFun() {
            /**判断区间范围是否正确--开始 */
            let type1 = false;
            let arr1 = this.carTwosArr;
            arr1.forEach((v, k) => {
                if (k > 0 && v.distance - arr1[k - 1].distance <= 0) {
                    type1 = true;
                }
            });
            console.log(JSON.parse(JSON.stringify(arr1)), type1);
            /**判断区间范围是否正确--结束 */
            if (type1) {
                this.$message({
                    message: "区间值范围不正确，请检查！",
                    type: "warning",
                });
            } else {
                this.basePriceListType = false;
                this.pumpPriceArr[this.carTwosArrIndex].list = this.carTwosArr;
                console.log(JSON.parse(JSON.stringify(this.pumpPriceArr)));
            }
        },
        //价格区间设置打开
        basePriceListFun(d, index) {
            this.basePriceListType = true;
            this.carTwosArr = d;
            this.carTwosArrIndex = index;
        },
        addJson() {
            //价格区间添加
            this.yunPriceArr.splice(this.yunPriceArr.length - 1, 0, {
                id: "",
                costName: 0, //距离
                costUnit: 0, //价格
                type: 1, //1新增；2修改 0删除
            });
            this.$forceUpdate();
        },
        delJson(k) {
            //价格区间删除
            this.yunPriceArr.splice(k, 1);
        },
        addJson2() {
            //调价里面的价格区间添加
            this.carTwosArr.splice(this.carTwosArr.length - 1, 0, {
                minDistance: 0,
                maxDistance: 0,
                distance: 1, //距离
                price: 0, //价格
            });
            this.$forceUpdate();
        },
        delJson2(k) {
            //调价里面的价格区间删除
            this.carTwosArr.splice(k, 1);
            this.$forceUpdate();
        },
        processModelFun() {
            this.formDate.business = [];
        },
        //获取已选择站点名称的业务点
        stationsControlPointFun(type) {
            if (this.formDate.stationsList.length == 0) {
                this.$message({
                    message: "请先选择站点！",
                    type: "warning",
                });
                return;
            }
            if (this.formDate.processModel == undefined) {
                this.$message({
                    message: "请先选择流程模式！",
                    type: "warning",
                });
                return;
            }
            getDicsType({ codes: "collaboration,nomarket,personaluse,market" }).then(res => {
                this.businessCheckbox = [];
                res.data.market.items.forEach(v => {
                    this.businessCheckbox.push(v);
                });
                if (!type) {
                    this.controlPoint_Dialog = true;
                    if (!this.formDate.id && this.formDate.processModel == 0) {
                        processes_collection(this.formDate.stationsList).then(res2 => {
                            if (res2.data?.length > 0) {
                                this.formDate.business = res2.data.filter(dataRes => this.businessCheckbox.some(box => box.id == dataRes)) || [];
                            }
                        });
                    }
                }
            });
        },
        companylistSecondChangeFun(type, companyId) {
            if (type) {
                this.formDate.stationsList = [];
            }
            this.sitelist = this.companylist.find(res => res.value == companyId).children;
        },
        //调用父级init
        init() {
            this.$emit("sumbit");
        },
        initt(data) {
            console.log(88);
            /*重置数据*/
            this.tableParam = data;
            this.gettableData();
        },
        srarch(data) {
            this.tableParam = data;
            this.gettableData();
        },
        //主合同单位选择后，带出对应参数
        async changemainCompanyId(e) {
            let item = this.companylist.find(res => res.id == e);
            this.formDate.firstParty = item.name;
            // let item = this.companylist.find(res => res.value == e);
            // this.formDate.firstParty = item.label;
        },
        async changesecondCompanyId(e) {
            console.log(e)
            let item = this.companylist.find(res => res.id == e);
            this.formDate.secondParty = item.name;
            // let item = this.companylist.find(res => res.id == e);
            // this.formDate.secondParty = item.typeName;
            // this.formDate.secondPartyId = item.typeId;
        },
        /*添加保存*/
        pagessubmitFromDate() {
            this.$refs.reffromDate.validate(valid => {
                if (valid) {
                    console.log(this.formDate)
                    // /**判断区间范围是否正确--开始 */
                    // let type1 = false;
                    // let arr1 = this.yunPriceArr;
                    // arr1.forEach((v, k) => {
                    //   if (k > 0 && k + 1 < arr1.length && v.costName - arr1[k - 1].costName <= 0) {
                    //     console.log(v.costName, arr1[k - 1].costName);
                    //     type1 = true;
                    //   }
                    // });
                    // if (type1) {
                    //   this.$message({
                    //     message: "区间值范围不正确，请检查！",
                    //     type: "warning",
                    //   });
                    //   return;
                    // }
                    // /**判断区间范围是否正确--结束 */
                    // //运输价格数据重组-开始
                    // let alldata = this.yunPriceArr.filter(res => this.formDate.foreign.yunPrice.some(item => res.id == item.id));
                    // alldata.forEach(res => {
                    //   res.type = 2; //2是修改
                    // });
                    // let deleteData = this.formDate.foreign.yunPrice.filter(res => !alldata.some(item => res.id == item.id));
                    // deleteData.forEach(res => {
                    //   res.type = 0; //0是删除
                    // });
                    // let addData = this.yunPriceArr.filter(res => !alldata.some(item => res.id == item.id));
                    // this.formDate.foreign.yunPrice = [...alldata, ...deleteData, ...addData];
                    // //运输价格数据重组-结束
                    // let type = false;
                    // this.pumpPriceArr.forEach(v => {
                    //   if (!v.costId) {
                    //     type = true;
                    //   }
                    // });
                    // if (type) {
                    //   this.$message({
                    //     message: "请检查表格数据是否完整！",
                    //     type: "warning",
                    //   });
                    //   return;
                    // }
                    // //泵送价格数据重组-开始
                    // let arr1_1 = [];
                    // //第一层对比开始,通过第一层自定义字段fzyId对比
                    // let alldata2 = this.pumpPriceArr.filter(res => this.formDate.foreign.pumpPrice.some(item => res.id == item.id));
                    // let deleteData2 = this.formDate.foreign.pumpPrice.filter(res => !alldata2.some(item => res.id == item.id));
                    // deleteData2.forEach(res => {
                    //   res.type = 0; //0是删除
                    // });
                    // let addData2 = this.pumpPriceArr.filter(
                    //   //新增的默认写死为 1；1
                    //   res => !alldata2.some(item => res.id == item.id)
                    // );
                    // arr1_1 = [...alldata2, ...deleteData2, ...addData2];
                    // // console.log(
                    // //   JSON.parse(JSON.stringify(arr1_1)),
                    // //   "新的第一层对比后"
                    // // );
                    // arr1_1.forEach((v, k) => {
                    //   this.formDate.foreign.pumpPrice.forEach(v2 => {
                    //     if (v.id == v2.id && v.list != null) {
                    //       let alldata2 = v.list.filter(res => v2.list.some(item => res.id == item.id));
                    //       alldata2.forEach(res => {
                    //         res.type = 2; //2是修改
                    //       });
                    //       let deleteData2 = v2.list.filter(res => !alldata2.some(item => res.id == item.id));
                    //       deleteData2.forEach(res => {
                    //         res.type = 0; //0是删除
                    //       });
                    //       let addData2 = v.list.filter(res => !alldata2.some(item => res.id == item.id));
                    //       arr1_1[k].list = [...alldata2, ...deleteData2, ...addData2];
                    //     }
                    //   });
                    // });
                    // this.formDate.foreign.pumpPrice = arr1_1;
                    // // console.log(
                    // //   JSON.parse(JSON.stringify(this.formDate.foreign.pumpPrice)),
                    // //   "最终组装后"
                    // // );
                    // //泵送价格数据重组-结束
                    // let type2 = false;
                    // this.goodPriceArr.forEach(v => {
                    //   if (!v.costId) {
                    //     type2 = true;
                    //   }
                    // });
                    // if (type2) {
                    //   this.$message({
                    //     message: "请检查表格数据是否完整！",
                    //     type: "warning",
                    //   });
                    //   return;
                    // }
                    // //产品价格数据重组-开始
                    // let alldata02 = this.goodPriceArr.filter(res => this.formDate.foreign.goodPrice.some(item => res.id == item.id));
                    // alldata02.forEach(res => {
                    //   res.type = 2; //2是修改
                    // });
                    // let deleteData02 = this.formDate.foreign.goodPrice.filter(res => !alldata02.some(item => res.id == item.id));
                    // deleteData02.forEach(res => {
                    //   res.type = 0; //0是删除
                    // });
                    // let addData02 = this.goodPriceArr.filter(res => !alldata02.some(item => res.id == item.id));
                    // this.formDate.foreign.goodPrice = [...alldata02, ...deleteData02, ...addData02];
                    // //产品价格数据重组-结束
                    // let type3 = false;
                    // this.fuPriceArr.forEach(v => {
                    //   if (!v.costId) {
                    //     type3 = true;
                    //   }
                    // });
                    // if (type3) {
                    //   this.$message({
                    //     message: "请检查表格数据是否完整！",
                    //     type: "warning",
                    //   });
                    //   return;
                    // }
                    // //附加收费项价格数据重组-开始
                    // let alldata03 = this.fuPriceArr.filter(res => this.formDate.foreign.fuPrice.some(item => res.id == item.id));
                    // alldata03.forEach(res => {
                    //   res.type = 2; //2是修改
                    // });
                    // let deleteData03 = this.formDate.foreign.fuPrice.filter(res => !alldata03.some(item => res.id == item.id));
                    // deleteData03.forEach(res => {
                    //   res.type = 0; //0是删除
                    // });
                    // let addData03 = this.fuPriceArr.filter(res => !alldata03.some(item => res.id == item.id));
                    // this.formDate.foreign.fuPrice = [...alldata03, ...deleteData03, ...addData03];
                    // //附加收费项价格数据重组-结束
                    // this.formDate.supplierTypeId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "typeId");
                    this.formDate.accessory = JSON.stringify(this.files);
                    // this.submitFromDate(this.formDate)
                    if (this.addDialogTitle == '添加') {
                        delete this.formDate.id
                    }
                    post(this.saveOrUpdate, this.formDate).then((res) => {
                        this.loading = false;
                        this.submitLoading = false;
                        if (res.code === 1001) {
                            this.$message({
                                message: '保存成功',
                                type: "success",
                            });
                            this.gettableData()
                        }
                        this.addDialog = false;
                    });
                } else {
                    this.$message({
                        message: "必填字段填写不完全！",
                        type: "warning",
                    });
                    return false;
                }
            });
        },
        //获取合同详情
        contractQueryDetailByIdFun(d) {
            if (this.$refs.reffromDate) {
                this.$refs.reffromDate.resetFields();
            }
            this.addDialog = true;
            this.modifyType = true;
            contractQueryDetailById({ id: d }).then(async res => {
                // this.formDate = res.data.data;
                console.log(res)
                this.formDate = { ...this.formDate, ...res.data };
                console.log('------------', this.formDate)
                this.changemainCompanyId(this.formDate.firstPartyId, true);
                this.changesecondCompanyId(this.formDate.secondPartyId, true);
                this.formDate.startDayendDay = [];
                this.formDate.startDayendDay[0] = this.formDate.startTime;
                this.formDate.startDayendDay[1] = this.formDate.endTime;
                // this.formDate. = this.copy(res.data.list.fuPrice)
                // this.formDate.foreign = {};
                // this.formDate.foreign.yunPrice = this.copy(res.data.list.yunPrice);
                // this.yunPriceArr = this.copy(res.data.list.yunPrice);
                // this.formDate.foreign.pumpPrice = this.copy(res.data.list.pumpPrice);
                // this.pumpPriceArr = this.copy(res.data.list.pumpPrice);
                // this.formDate.foreign.goodPrice = this.copy(res.data.list.goodPrice);
                // this.goodPriceArr = this.copy(res.data.list.goodPrice);
                // this.formDate.foreign.fuPrice = this.copy(res.data.list.fuPrice)
                // this.fuPriceArr = this.copy(res.data.list.fuPrice);
                // this.splitPriceArr = this.copy(res.data.list.splitPrice);
                this.files = JSON.parse(this.formDate.accessory) || [];
                // await this.companylistChangeFun(false, this.formDate.firstPartyId); //选择甲方公司后显示对应站点名称
                //判断公司-站点权限是否包含返回的详情id值，在就回显，不在就回显提示信息placeholder
                console.log(JSON.parse(JSON.stringify(this.formDate)));
            });
        },
        //调价列表
        riseInPriceQueryOneByidFun(d) {
            this.low2 = d;
            this.dialog2 = true;
            // this.contractId = d.id;
            // this.riseInPriceQueryOneByidType = true;
            // contractQueryDetailById({ id: d.id }).then(async res => {
            //   this.formDate = res.data.contract;
            //   await this.companylistChangeFun(true, this.formDate.firstPartyId); //选择甲方公司后显示对应站点名称
            //   this.yunPriceArr = this.copy(res.data.list.yunPrice);
            //   this.pumpPriceArr = this.copy(res.data.list.pumpPrice);
            //   this.goodPriceArr = this.copy(res.data.list.goodPrice);
            //   this.fuPriceArr = this.copy(res.data.list.fuPrice);
            // });
        },
        //价格设置-调价详情-列表
        QueryOneByidFun(d, moneyType) {
            this.QueryOneByidType = true;
            this.modifyType = false;
            this.QueryOneByidArr = [];
            this.contractRawMoneySaveForm.startTime = "";
            this.QueryOneByidObject.contractId = this.contractId;
            if (d) {
                this.QueryOneByidObject.rawId = d.id;
                this.moneyType = moneyType;
            }
            if (this.moneyType) {
                this.QueryOneByidObject.contractFacility = this.QueryOneByidObject.rawId;
                PumpPriceLogQueryPage(this.QueryOneByidObject).then(res => {
                    this.QueryOneByidArr = res.data;
                });
                this.carTwosArr = d.list;
                console.log(JSON.parse(JSON.stringify(d)));
                // if (d.id == 1) {
                this.carTwosArr = [];
                this.yunPriceArr.forEach((v, k) => {
                    let json = {
                        minDistance: k == 0 ? 0 : this.yunPriceArr[k - 1].costName,
                        maxDistance: v.costName,
                        price: v.costUnit, //价格
                        addDistance: v.costDetail, //每增加距离
                    };
                    this.carTwosArr.push(json);
                });
                // }
            } else {
                QueryOneByid(this.QueryOneByidObject).then(res => {
                    this.QueryOneByidArr = res.data.data;
                    this.QueryOneByidObject.total = res.data.totalRows;
                });
            }
        },
        basePriceListFun2(d) {
            this.basePriceListType2 = true;
            let obj = {
                contractId: d.contractId,
                contractFacility: d.contractFacility,
                startTime: d.startTime,
            };
            PumpPriceLogGetDetail(obj).then(res => {
                if (res.code == 1001) {
                    this.carTwosArr2 = res.data;
                }
            });
        },
        //价格设置，提交
        contractRawMoneySaveFun() {
            if (!this.files2?.length) {
                return this.$message.warning("请上传附件文件");
            }
            this.$refs.contractRawMoneySaveForm.validate(valid => {
                if (valid) {
                    this.contractRawMoneySaveForm.contractId = this.contractId;
                    this.contractRawMoneySaveForm.rawId = this.QueryOneByidObject.rawId;
                    this.contractRawMoneySaveForm.contractFacility = this.QueryOneByidObject.rawId;
                    this.contractRawMoneySaveForm.filePaths = JSON.stringify(this.files2);
                    if (this.moneyType) {
                        /**判断区间范围是否正确--开始 */
                        let type1 = false;
                        let arr1 = this.carTwosArr;
                        arr1.forEach((v, k) => {
                            if (k > 0 && v.minDistance - arr1[k - 1].minDistance <= 0) {
                                type1 = true;
                            }
                        });
                        console.log(JSON.parse(JSON.stringify(arr1)), type1);
                        /**判断区间范围是否正确--结束 */
                        if (type1) {
                            this.$message({
                                message: "区间值范围不正确，请检查！",
                                type: "warning",
                            });
                        } else {
                            this.contractRawMoneySaveForm.list = this.carTwosArr;
                            //泵车价格区间的
                            PumpPriceLogSave(this.contractRawMoneySaveForm).then(res => {
                                if (res.code == 1001) {
                                    this.QueryOneByidFun();
                                }
                            });
                        }
                    } else {
                        contractRawMoneySave(this.contractRawMoneySaveForm).then(res => {
                            if (res.code == 1001) {
                                this.QueryOneByidFun();
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        //删除价格
        contractRawMoneyDeletesFun(d) {
            if (this.moneyType) {
                //泵车价格区间的
                let obj = {
                    contractId: this.contractId,
                    contractFacility: d.contractFacility,
                    startTime: d.startTime,
                };
                PumpPriceLogDeletes(obj).then(() => {
                    this.QueryOneByidFun();
                });
            } else {
                contractRawMoneyDeletes({ id: d.id }).then(() => {
                    this.QueryOneByidObject.page = 1;
                    this.QueryOneByidFun();
                });
            }
        },
        //协作单位组合
        queryListsByPidFun(d) {
            this.contractId = d.id;
            this.AllqueryListsByPid = true;
            console.log(d);
            queryListsByPid({ supplierId: d.supplierId }).then(res => {
                this.queryListsByPidArr = res.data;
                // let obj = {
                //   id: d.supplierId,
                //   name: d.supplierName,
                // };
                // this.queryListsByPidArr.splice(0, 0, obj);
            });
        },
        //开户信息详情
        contractAccountGetDetailFun(d) {
            this.contractAccountSaveForm = {};
            this.contractAccountGetDetailType = true;
            let obj = {
                contractId: d.id,
                pid: d.supplierId,
                type: 1,
            };
            contractAccountGetDetail(obj).then(res => {
                this.contractAccountSaveForm = res.data;
                this.$refs.contractAccountSaveForm.resetFields();
            });
        },
        //开户信息保存
        contractAccountSaveFun() {
            this.$refs.contractAccountSaveForm.validate(valid => {
                if (valid) {
                    // this.formDate.contractPact = this.$fromatTable(
                    //   this.contractPactIdArr,//未知
                    //   this.formDate.contractPactId,
                    //   "id",
                    //   "name"
                    // );
                    contractAccountSave(this.contractAccountSaveForm).then(res => {
                        if (res.code == 1001) {
                            this.contractAccountGetDetailType = false;
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        //重置表格-渲染
        reset() {
            this.modifyType = false;
            this.formDate = {
                processPrice: '', //加工费用
                productPrice: '', //产品费用
                startDayendDay: [],
                id: "",
                contractTypeId: null,//合同类型id
                contractType: "",
                firstParty: "", //甲方
                firstPartyId: "", //甲方id
                secondParty: "", //乙方
                secondPartyId: "", //乙方ID
                accessory: [], //附件
            },
                this.files = [];
        },
        //重置表格-渲染
        resetCarTwos() {
            this.formDate.foreign.yunPrice = [
                {
                    id: "",
                    costName: 1, //距离
                    costUnit: 0, //价格
                    type: 1, //1新增；2修改 0删除
                },
                {
                    id: "",
                    costName: 2, //距离
                    costUnit: 0, //价格
                    type: 1, //1新增；2修改 0删除
                },
                {
                    id: "",
                    costName: 9999999, //距离
                    costUnit: 0, //价格
                    type: 1, //1新增；2修改 0删除
                },
            ];
            this.$forceUpdate();
        },
        //重置表格-渲染
        resetPumpPrice() {
            this.formDate.foreign.pumpPrice = [];
        },
        //站点选择后重置
        stationsTypeFun() {
            this.formDate.business = [];
        },
        //泵列表选择后赋值泵类型
        pumpTypeId_pumpTypeFun(e, k, name) {
            if (name == "泵车类型") {
                let type = false;
                this.pumpPriceArr.findIndex((v, index) => {
                    if (v.costId == e.costId && k != index) {
                        type = true;
                    }
                });
                if (type) {
                    this.$message({
                        message: "该泵车类型已存在！",
                        type: "warning",
                    });
                    e.costId = "";
                    return;
                }
                this.pumpPriceArr[k].costName = this.$fromatTable(this.pumpTypeArr, e.costId, "id", "itemName");
            } else if (name == "强度等级") {
                let type = false;
                this.goodPriceArr.findIndex((v, index) => {
                    if (v.costId == e.costId && k != index) {
                        type = true;
                    }
                });
                if (type) {
                    this.$message({
                        message: "该强度等级已存在！",
                        type: "warning",
                    });
                    e.costId = "";
                    return;
                }
                this.goodPriceArr[k].costName = this.$fromatTable(this.goodPriceList, e.costId, "id", "name");
            } else if (name == "附加收费项") {
                let type = false;
                this.fuPriceArr.findIndex((v, index) => {
                    if (v.costId == e.costId && k != index) {
                        type = true;
                    }
                });
                if (type) {
                    this.$message({
                        message: "该附加收费项已存在！",
                        type: "warning",
                    });
                    e.costId = "";
                    return;
                }
                this.fuPriceArr[k].costName = this.$fromatTable(this.fuPriceList, e.costId, "ID", "NAME");
            }
        },
        //泵列表添加一条数据
        addItemPumpList(name) {
            let obj = {
                id: "",
                costName: "", //名称
                costId: "", //名称id
                costUnit: 0, //价格
                type: 1,
            };
            if (name == "泵车类型") {
                let data = {
                    id: "",
                    deviceName: "", //设备名称
                    deviceId: "", //设备id
                    basePrice: 0, //单价
                    assessmentPrice: 0, //考核价
                    type: 1,
                    list: [
                        {
                            id: "",
                            distance: 1, //距离
                            price: 0, //价格
                            addDistance: 0, //每增加距离
                            type: 1, //1新增，2修改，0删除
                        },
                        {
                            id: "",
                            distance: 2, //距离
                            price: 0, //价格
                            addDistance: 0, //每增加距离
                            type: 1, //1新增，2修改，0删除
                        },
                        {
                            id: "",
                            distance: 9999999, //距离
                            price: 0, //价格
                            addDistance: 0, //每增加距离
                            type: 1, //1新增，2修改，0删除
                        },
                    ],
                };
                this.pumpPriceArr.push(data);
            } else if (name == "强度等级") {
                obj.costDetail = 0;
                obj.costUnit = 0;
                this.goodPriceArr.push(obj);
            } else if (name == "附加收费项") {
                obj.costDetail = 0;
                obj.costUnit = 0;
                this.fuPriceArr.push(obj);
            }
            this.$forceUpdate();
        },
        deleteItemPumpList(index, name) {
            if (name == "泵车类型") {
                this.pumpPriceArr.splice(index, 1);
            } else if (name == "强度等级") {
                this.goodPriceArr.splice(index, 1);
            } else if (name == "附加收费项") {
                this.fuPriceArr.splice(index, 1);
            }
        },
        /**合同编号是否重复 */
        queryContractNumberFun() {
            queryContractNumber({ contractNumber: this.formDate.contractNumber, id: this.formDate.id }).then(res => {
                if (res.code == 1001 && !res.data) {
                    this.$message({
                        message: "合同编号重复！",
                        type: "warning",
                    });
                    this.formDate.contractNumber = "";
                }
            });
        },
        handleAvatarSuccess1(res) {
            if (res.code === 1001) {
                console.log(res.data);
                this.appPackage = [];
                this.formDate.appPackage = res.data.fileName;
                this.formDate.accessory = res.data.fileUrl;
            }
        },
        beforeAvatarUpload1(file) {
            console.log(file);
        },
        /**区间填入值不能小于等于前一个大于等于后一个 */
        inpuSizeCheck(val, k, arr) {
            console.log(val, k);
            if (arr.length == k + 2 && k > 0) {
                arr[k + 1].costName = val;
            }
            let frontNumber = "",
                afterNumber = "";
            let l = k - 1;
            if (k < 0) {
                frontNumber = 0;
            } else {
                for (l; l >= 0; l--) {
                    frontNumber = arr[l].costName;
                    break;
                }
            }
            let i = k + 1;
            for (i; i < arr.length; i++) {
                afterNumber = arr[i].costName;
                break;
            }
            console.log(JSON.parse(JSON.stringify(arr)));
            console.log(val, frontNumber, afterNumber);
            if (val - frontNumber <= 0) {
                console.log(val + ":" + frontNumber);
                this.$message({
                    message: "区间值范围不正确，请检查！",
                    type: "warning",
                });
            } else if (arr.length != k + 2 && afterNumber - val <= 0) {
                console.log(afterNumber + ":" + val);
                this.$message({
                    message: "区间值范围不正确，请检查！",
                    type: "warning",
                });
            }
        },
        /**区间填入值不能小于等于前一个大于等于后一个 */
        inpuSizeCheck2(val, k, arr) {
            let frontNumber = "",
                afterNumber = "";
            let l = k - 1;
            for (l; l >= 0; l--) {
                frontNumber = arr[l].distance;
                break;
            }
            let i = k + 1;
            if (i == arr.length) {
                afterNumber = 9999999;
            } else {
                for (i; i < arr.length; i++) {
                    afterNumber = arr[i].distance;
                    break;
                }
            }
            if (val - frontNumber <= 0) {
                console.log(val + ":" + frontNumber);
                this.$message({
                    message: "区间值范围不正确，请检查！",
                    type: "warning",
                });
            } else if (afterNumber - val <= 0) {
                console.log(afterNumber + ":" + val);
                this.$message({
                    message: "区间值范围不正确，请检查！",
                    type: "warning",
                });
            }
        },
        /**区间填入值不能小于等于前一个大于等于后一个 */
        inpuSizeCheck3(val, k, arr) {
            let frontNumber = "",
                afterNumber = "";
            let l = k - 1;
            for (l; l >= 0; l--) {
                frontNumber = arr[l].minDistance;
                break;
            }
            let i = k + 1;
            if (i == arr.length) {
                afterNumber = 9999999;
            } else {
                for (i; i < arr.length; i++) {
                    afterNumber = arr[i].minDistance;
                    break;
                }
            }
            if (val - frontNumber <= 0) {
                console.log(val + ":" + frontNumber);
                this.$message({
                    message: "区间值范围不正确，请检查！",
                    type: "warning",
                });
            } else if (afterNumber - val <= 0) {
                console.log(afterNumber + ":" + val);
                this.$message({
                    message: "区间值范围不正确，请检查！",
                    type: "warning",
                });
            }
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
    },
    filters: {
        //价格设置，是否显示价格输入框，对应价格区间显示
        moneyFun(moneyType) {
            if (moneyType) {
                return true;
            } else {
                return false;
            }
        },
        //站点list表格中拼接展示
        stationsFun(arr) {
            if (arr) {
                let ket = JSON.parse(arr).map(res => {
                    return res.name;
                });
                return ket.join("、");
            } else {
                return "";
            }
        },
    },
};
</script>
  
<style lang="scss" scoped>
.dialoginfo {

    .el-input,
    .el-select {
        width: 230px;
    }
}

.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin-left: 10px;
    color: $bg_color;
}

.table_link:hover {
    opacity: 0.8;
}

.form-title {
    font-size: 18px;
    margin: 10px 0;
}

.FZYguanKongYeWuDian {
    display: flex;

    >table {
        flex: none;
        width: 100px;
    }

    >div {
        flex: 1;
    }
}

.FZY1-3 {
    border-bottom: 1px solid #f2f2f2;

    .liBox1,
    .liBox2 {
        padding: 10px;
        width: 520px;
        display: flex;

        >div:nth-of-type(1) {
            width: 210px;
        }

        >div:nth-of-type(2) {
            flex: 1;
        }

        span {
            display: inline-block;
            margin-left: 20px;
        }

        .el-input-number ::v-deep {
            margin-left: 20px;
        }
    }

    .liBox3 {
        padding: 10px;
        width: 650px;
        display: flex;

        >div:nth-of-type(1) {
            display: flex;

            >div:nth-of-type(1) {
                width: 210px;

                span {
                    margin-left: 10px;
                }

                .el-input-number ::v-deep {
                    margin-left: 10px;
                    width: 80px;
                }
            }

            span {
                display: inline-block;
                margin-left: 20px;
            }

            .el-input-number ::v-deep {
                margin-left: 20px;
            }
        }

        >div:nth-of-type(2) {
            width: 130px;
            flex: none;
            line-height: 28px;
            padding-left: 20px;
        }
    }
}
</style>
<style lang="scss">
.outsourcing {

    // .FZYcheckbox {
    //   .el-checkbox {
    //     min-width: 155px;
    //     margin-right: 0px;
    //   }
    // }
    .FZYform {
        padding-top: 0px !important;

        .el-form-item {
            min-width: 445px;

            .el-input,
            .el-select {
                width: 340px;
            }

            .hyyc {
                width: 310px;

                .el-input {
                    width: 310px;
                }
            }
        }
    }

    .FZYform2 {
        .el-form-item__error {
            white-space: nowrap;
        }
    }

    .FZYselectList {
        .el-select {
            width: 85px !important;
            margin-right: 10px;
        }
    }
}
</style>
  